import cn from "classnames";
import BookIndex from "components/shared/book/list";
import { Transition } from "components/shared/column";
import SharedReactTable from "components/shared/reactTable";
import { billingPaymentTypes, tariffTypes } from "helpers/enums";
import { FilterProps, isDeletedColumn, rowIndexColumn, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { enumLabel } from "helpers/system";
import React, { FC } from "react";
import { deleteTariff, restoreTariff, syncTariffs } from "sources/admin";

class AdminTariffs extends BookIndex {
    state: any;

    constructor(props: any) {
        super(props);
        this.state = {
            ...this.state,
            loading: false,
        };
    }

    componentWillUnmount() {
        this.props.clearParams();
    }

    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            { Header: "ID биллинга", accessor: "externalId", filterable: true, filterType: "int" },
            { Header: "Название", accessor: "name", filterable: true },
            {
                Header: "Тип тарифа",
                accessor: "type",
                filterable: true,
                filterType: "enum",
                Filter: (props: FilterProps) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "type" },
                            options: tariffTypes,
                        }}
                    />
                ),
                Cell: ({ value }: { value: string }) => enumLabel(tariffTypes, value),
            },
            {
                Header: "Тип оплаты",
                accessor: "paymentType",
                filterable: true,
                filterType: "enum",
                Filter: (props: FilterProps) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            inputProps: { name: "paymentType" },
                            options: billingPaymentTypes,
                        }}
                    />
                ),
                Cell: ({ value }: { value: string }) => enumLabel(billingPaymentTypes, value),
            },
            isDeletedColumn(
                (id) =>
                    this.props.modal({
                        name: "confirm",
                        title: "Восстановление тарифа",
                        text: "Вы действительно хотите восстановить тариф?",
                        action: () => restoreTariff({ id: Number(id) }).then(() => this.props.mergeParams({})),
                        buttons: { confirm: "Восстановить", cancel: "Отмена" },
                    }),
                true,
            ),
            {
                Header: "Действие",
                width: 120,
                notExportable: true,
                id: "action",
                sortable: false,
                Cell: ({ row: { original } }: { row: { original: any } }) => {
                    if (original.isDeleted) {
                        return null;
                    }
                    return (
                        <div className="text-center">
                            <button
                                type="button"
                                className="btn btn-xs btn-outline-danger"
                                onClick={() => this.deleteItem(original)}
                            >
                                Удалить
                            </button>
                        </div>
                    );
                },
            },
        ];
    }

    deleteItem = (data: any) => {
        this.props.modal({
            name: "confirm",
            title: "Удаление тарифа",
            text: "Вы действительно хотите удалить тариф?",
            buttons: { confirm: "Удалить", cancel: "Отмена" },
            action: () => deleteTariff({ id: data.id }).then(() => this.props.mergeParams({})),
        });
    };

    syncItems = () => {
        this.setState({ loading: true });
        syncTariffs()
            .then(() => {
                this.setState({ loading: false });
                this.props.mergeParams({});
            })
            .catch(() => this.setState({ loading: false }));
    };

    renderHead = () => {
        return (
            <div className="book-list__head-wrap">
                <div className="book-list__head">
                    <div className="book-list__head-close close close--sm" onClick={this.close} aria-label="Закрыть" />
                    <div className="book-list__head-title">
                        Тарифы
                        {this.renderCounter()}
                    </div>
                    <div className="btn-toolbar">
                        <button
                            type="button"
                            className="btn btn-sm btn-brand"
                            disabled={this.state.loading}
                            onClick={this.syncItems}
                        >
                            {this.state.loading ? "Синхронизация..." : "Синхронизировать"}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;

    render() {
        const { nofilter, listRoute } = this.props;
        const cname = cn("page-book__list book-list list", { "book-list--nofilter": !!nofilter });
        return (
            <div className="page-content">
                <Transition dir="full" {...listRoute}>
                    <div className={cname}>
                        {this.renderHead()}
                        <div className="container-fluid my-2">{this.renderActions()}</div>
                        {this.renderListComponent()}
                    </div>
                </Transition>
            </div>
        );
    }
}

export default tableContainer(AdminTariffs as unknown as FC, "admin-tariffs");
